import React from 'react';
import { Modal } from 'semantic-ui-react';
import { useFacility } from '../../contexts/facility/FacilityContext';
import './style.less';

interface PostAcknowledgmentModalProps {
    open: boolean;
    onAcknowledge: () => void;
    onClose: () => void;
    isSubmitting?: boolean;
}

const FALLBACK_MESSAGE = 'This will be seen by all residents and staff. Please keep it kind and respectful.';

const PostAcknowledgmentModal = ({ open, onAcknowledge, onClose, isSubmitting }: PostAcknowledgmentModalProps) => {
    const { facilityDetails, loading } = useFacility();
    const message = facilityDetails?.PostDefaultMessage || FALLBACK_MESSAGE;
    const showLoader = loading && !facilityDetails;

    return (
        <Modal open={open} onClose={onClose} className="before-post-modal" closeOnDimmerClick>
            <Modal.Content className="before-post-body">
                <div className="before-post-icon">
                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" />
                    </svg>
                </div>
                <div className="before-post-title">Before You Post</div>
                {showLoader ? (
                    <div className="before-post-loading" role="status" aria-live="polite" aria-label="Loading message">
                        <span className="before-post-spinner" />
                        <span className="before-post-loading-text">Loading...</span>
                    </div>
                ) : (
                    <p className="before-post-text">{message}</p>
                )}
            </Modal.Content>
            <Modal.Actions className="before-post-actions">
                <button type="button" className="before-post-btn before-post-btn-cancel" onClick={onClose} disabled={isSubmitting}>
                    Cancel
                </button>
                <button
                    type="button"
                    className="before-post-btn before-post-btn-ack"
                    onClick={onAcknowledge}
                    disabled={showLoader || isSubmitting}
                >
                    I Acknowledge
                </button>
            </Modal.Actions>
        </Modal>
    );
};

export default PostAcknowledgmentModal;
